import FF from "@/components/forms/FormField.module.css";

import { FormFieldChildren, type FormFieldChildrenProps } from "@/components/forms/FormField.tsx";
import { standardFieldAttributes, type StandardFieldProps } from "@/components/forms/standardFieldAttributes.tsx";
import { cn } from "@/utils/classNames.ts";
import type { NumberFieldProps } from "react-aria-components";
import { NumberField } from "react-aria-components";

export interface WNumberFieldProps
    extends
        Omit<NumberFieldProps, "children" | "className">,
        StandardFieldProps,
        Pick<FormFieldChildrenProps, "wide" | "description" | "children" | "label" | "errorMessage"> {
    className?: string;
    block?: boolean;
    headless?: boolean;
}

export function WNumberField({
    className,
    children,
    wide,
    block,
    headless,
    description,
    label,
    errorMessage,
    ...props
}: WNumberFieldProps) {
    return (
        <NumberField
            className={cn(FF.FormField, className, block && FF.Block, headless && FF.Headless)}
            {...props}
            formatOptions={{ useGrouping: false, ...props.formatOptions }}
            {...standardFieldAttributes(props)}
        >
            <FormFieldChildren wide={wide} description={description} label={label} errorMessage={errorMessage}>
                {children}
            </FormFieldChildren>
        </NumberField>
    );
}
